import { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

import './RainWaterHarvest.css';
import ImageGalleryCard from '../gallery/ImageGalleryCard';

const RAIN_WATER_HARVEST_IMAGES = [
  {
    src: '/images/parks/park1.webp',
    thumbnail: '/images/parks/park1.webp',
    title: 'Restored Borewell',
  },
  {
    src: '/images/parks/park2.webp',
    thumbnail: '/images/parks/park2.webp',
    title: 'Revived Harvesting Pits',
  },
  {
    src: '/images/parks/park3.webp',
    thumbnail: '/images/parks/park3.webp',
    title: 'Rainwater Redirection',
  },
];

const RainWaterHarvest = () => {
  const [showList, setShowList] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowList(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Container className="mt-4 ps-0 pe-0">
        <h4 className="mb-4 text-left">Rain Water Harvesting</h4>

        {/* Description & Video */}
        <Row className="mb-4">
          <Col md={6}>
            <p>
              In order to build a sustainable society living in peace & harmony,
              a sustainable plan for water management that provides direction
              for efficient management of water resources is essential. At
              Aparna Western Meadows, we started embarking on that journey from
              2021.
              <br />
              <br />
              Our aim is to holistically understand various sources of water,
              consumption patterns across various uses, conservation methods to
              be deployed, water budgeting & water regulation to build a
              long-term plan for sustainable water management. The supply of
              water from any source i.e. government supply or borewells is
              limited. The study, analysis and subsequent plan developed should
              factor the long-term requirements and challenges to provide a
              roadmap that meets all objectives - sustainable supply, affordable
              cost & responsible consumption.
            </p>
          </Col>
          <Col md={6}>
            <div className="rain-water-harvest-video">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/apYgSxfEz14?si=nuK_K-3_pbfbVOTD"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </Col>
        </Row>

        {/* Key Highlights & Gallery */}
        <Row className="mb-4">
          <Col md={12}>
            <div id="key-highlights">
              <h5>Key Highlights</h5>
              {showList && (
                <ul className="fs-6 ps-3 rain-water-harvest-list">
                  <li className="rain-water-harvest-item">
                    3 injection borewells have been restored.
                  </li>
                  <li className="rain-water-harvest-item">
                    250 water harvesting pits have been revived.
                  </li>
                  <li className="rain-water-harvest-item">
                    Rainwater from terraces has been redirected to rainwater
                    pits.
                  </li>
                </ul>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RainWaterHarvest;
